import React from 'react';

import * as S from './fare-options.styles';

const SeoSrpFareOptions = ({ fareOptions, selectedFareOption, selectFareOption }) => {
  return (
    <S.FareOptionsContainer>
      <S.FareOptionHeading className="dF alignItemsCenter font18">
        <h2 className="quicksand font20"> Looking for a Discounted Fare? </h2>
      </S.FareOptionHeading>
      <S.FareOptionListWrapper>
        <S.FareOptionList className="dF">
          {Object.keys(fareOptions).map(key => {
            const fareOptionsArray = fareOptions[key];
            {
              return fareOptionsArray.map(item => {
                if (item.flavour.indexOf('desktop') > -1) {
                  return (
                    <S.FareOptionListElement
                      selected={selectedFareOption === item.faretype}
                      onClick={() => selectFareOption(item.fareType, item.identifier)}
                    >
                      <span>{item.details.text}</span>
                    </S.FareOptionListElement>
                  );
                }
                return null;
              });
            }
          })}
        </S.FareOptionList>
      </S.FareOptionListWrapper>
      <S.ImpInfo className="quicksand font12 white fb">
        Select one from below to avail discounted fares on select airlines
      </S.ImpInfo>
    </S.FareOptionsContainer>
  );
};

export default SeoSrpFareOptions;
